import axios from 'axios';
import { buildPtoDecisionPlaceholders } from './ptoDecisionPlaceholders';
import { printTemplateDocument, buildTemplateDocumentHtml } from './printDocument';

// Fetches the template and resolves its placeholders for a specific request. Shared by both
// printing and emailing so the two always produce the same document.
async function loadDecisionDocument({ salonId, templateId, request, employee, t, formatDate, printDate, approverName, ptoYear }) {
  const token = localStorage.getItem('token');
  const response = await axios.get(`/api/salons/${salonId}/pto/decision-templates/${templateId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });

  const template = response.data.template || response.data;
  const content = template.template_content;

  if (!content) {
    throw new Error(t('timeOff.pto.decisionTemplateNoContent', 'This template has no content'));
  }

  const placeholderMap = await buildPtoDecisionPlaceholders({
    salonId, request, employee, formatDate, printDate, approverName, ptoYear
  });

  return {
    title: template.title || t('timeOff.pto.printDecision', 'Print decision'),
    templateContent: content,
    placeholderMap
  };
}

export async function printPtoDecision(options) {
  const { title, templateContent, placeholderMap } = await loadDecisionDocument(options);

  printTemplateDocument({
    title,
    templateContent,
    placeholderMap,
    contentClass: 'contract-content'
  });
}

// Renders the same document the print path produces and hands it to the server, which turns it
// into a PDF and mails it to the employee (admins in bcc). The HTML is built here rather than
// server-side because the placeholder values come from several client-side calls, and because
// sharing one builder is what guarantees the PDF matches what printing would put on paper.
export async function emailPtoDecision(options) {
  const { salonId, request, emailSubject, emailBody } = options;
  const { title, templateContent, placeholderMap } = await loadDecisionDocument(options);

  const html = buildTemplateDocumentHtml({
    title,
    templateContent,
    placeholderMap,
    contentClass: 'contract-content'
  });

  const token = localStorage.getItem('token');
  const response = await axios.post(
    `/api/salons/${salonId}/pto/requests/${request.id}/decision-email`,
    { html, documentTitle: title, subject: emailSubject, body: emailBody },
    { headers: { Authorization: `Bearer ${token}` } }
  );

  return response.data;
}
